import { render, staticRenderFns } from "./lianghua.vue?vue&type=template&id=3f200dcf&scoped=true&"
import script from "./lianghua.vue?vue&type=script&lang=js&"
export * from "./lianghua.vue?vue&type=script&lang=js&"
import style0 from "./lianghua.vue?vue&type=style&index=0&id=3f200dcf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f200dcf",
  null
  
)

export default component.exports